import React from 'react';
import {
  Flex,
  Image,
  useColorModeValue,
  FlexProps,
} from '@chakra-ui/react';
import JIMIWellnessLogo from './JIMIWellnessLogo';
import useLogoUrl from '../hooks/useLogoUrl';

interface BrandingBannerProps extends FlexProps {
  /**
   * Whether to show the tagline "For Healthcare Professionals" on the JIMI logo
   */
  showTagline?: boolean;
  
  /**
   * Size of the JIMI Wellness logo
   */
  jimiLogoSize?: 'sm' | 'md' | 'lg';
  
  /**
   * Height of the Methodist logo in pixels
   */
  methodistLogoHeight?: string;
}

/**
 * A reusable component that displays the Houston Methodist logo and JIMI Wellness logo
 * in a unified horizontal banner for consistent branding across slides.
 */
const BrandingBanner: React.FC<BrandingBannerProps> = ({
  showTagline = true,
  jimiLogoSize = 'md',
  methodistLogoHeight = '40px',
  ...flexProps
}) => {
  const { logoUrl } = useLogoUrl();
  const bgColor = useColorModeValue('white', 'gray.800');
  const borderColor = useColorModeValue('gray.100', 'gray.700');
  
  return (
    <Flex
      w="100%"
      bg={bgColor}
      borderBottom="1px solid"
      borderColor={borderColor}
      py={3}
      px={6}
      justify="space-between"
      align="center"
      borderRadius="md"
      boxShadow="sm"
      {...flexProps}
    >
      {/* Methodist Logo */}
      {logoUrl && (
        <Image
          src={logoUrl}
          alt="Houston Methodist"
          h={methodistLogoHeight}
          objectFit="contain"
        />
      )}
      
      {/* JIMI Wellness Logo */}
      <JIMIWellnessLogo 
        size={jimiLogoSize} 
        showTagline={showTagline} 
      />
    </Flex>
  );
};

export default BrandingBanner;
